































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { TechnicalReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import ActivityRow from './Components/ActivityRow.vue';
import HeaderInfo from "@/components/App/Modules/GMS/Grants/ExpansionPanel/TechExpansionPanel.vue";
import NavButtons from '@/components/common/Buttons/NavButtons.vue';
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";

const namespace: string = "technicalReport";
@Component({
  components: {
    ActivityRow,
    HeaderInfo,
    NavButtons,
    VJsonschemaForm
  }
})
export default class PerformanceReportComponent extends Vue {
  @State(namespace) technicalReport!: TechnicalReportData;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Getter('selectedReport', {namespace}) report: any;
  @Prop() technicalReportSections: any;
  @Prop() formOptions: any;
  @Prop() model: any;
  @Prop() selectedReport: any;
  @Prop() schema: any;
  @Prop() forecastPeriod: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() enableButton: any;
  @Prop() logFrameWork:any;

  performanceStatus = _app.performanceStatus;
  options: any = {};
  schemaformKey: number = 0;

  mounted()
  {
  }

  get computedModel() {
     if(this.selectedReport.performanceReport==null)
    {
      this.selectedReport.performanceReport=[]
    }
   if (this.selectedReport && this.selectedReport.performanceReport.length === 0) {
      this.selectedReport.performanceReport = utils.clone(this.model.logframework);
    }
    return this.selectedReport;
  }

  get props() {
    if(this.schema && this.schema.properties) {
      let template = this.schema.properties;
      if(this.forecastPeriod.length === 0) {
        delete template["plans"];
      }
      return template;
    }
  }

  /** input event */
  showInput(e) {
    this.$emit("input", true);
  }

}
